import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { SERVER_URL } from '../initalState';

export const trackingApiSlice = createApi({
  reducerPath: 'trackingApi',
  baseQuery: fetchBaseQuery({
    baseUrl: SERVER_URL+"/qiktrack",
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  endpoints: (builder) => ({
 
    getCompanyData: builder.query({
      query: (companyId) => `/company/${companyId}`,
      transformResponse: (response) => response,
      transformErrorResponse: (response) => ({
        status: response.status,
        message: response.data || 'Error fetching company data',
      }),
    }),

    
  }),
});

export const {  useGetCompanyDataQuery } = trackingApiSlice;